import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative bg-foreground-900 text-background-50 rounded-2xl mx-4 md:mx-6 mb-6 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none flex items-end justify-end overflow-hidden">
        <span className="text-[180px] md:text-[260px] font-heading font-bold text-foreground-800/20 leading-none whitespace-nowrap translate-y-10 translate-x-10">
          HOOBUY
        </span>
      </div>

      <div className="relative z-10 px-6 md:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-xl font-heading font-semibold text-background-50 mb-6">
              Hoobuy Sheet
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-[260px]">
              A sua fonte número um para descobrir os melhores produtos da China. Atualizado diariamente.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              Navegação
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  Início
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  hoobuyspreadsheet
                </a>
              </li>
              <li>
                <Link to="/artigo/hoobuyspreadsheet-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  Guia Completo
                </Link>
              </li>
              <li>
                <Link to="/artigo/produtos-mais-vendidos" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  Categorias
                </Link>
              </li>
              <li>
                <Link to="/artigo/como-comprar-china-seguro" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                  Privacidade
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              Categorias Populares
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              Comece Agora
            </h4>
            <p className="text-sm text-foreground-300 mb-4 leading-relaxed">
              Pronto para descobrir os melhores produtos? Visite a nossa plataforma principal.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Aceder ao Hoobuy Sheet
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </div>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} hoobuy.boutique — Todos os direitos reservados.
          </p>
          <p className="text-xs text-foreground-400">
            Este site contém links de afiliado. Podemos receber uma comissão por compras realizadas.
          </p>
        </div>
      </div>
    </footer>
  );
}